/**
 * Каскад «Кластер → Регіон» у формах задачі: регіон обирається лише серед регіонів
 * обраного кластера; поки кластер не обрано, поле регіону заблоковане.
 */

/**
 * Код кластера зі значення select-поля: об'єкт ресурсу (`{ code, '@id' }`) або IRI
 * `/services/lists/clusters/<code>` (первинне поле довідника — code).
 */
export const clusterCodeOf = (value: any): string | null => {
    if (!value) return null
    if (typeof value === 'object' && value.code) return value.code
    const iri = typeof value === 'object' ? value['@id'] : value
    return typeof iri === 'string' ? iri.split('/').pop() || null : null
}

/** Фільтр опцій регіону: лише активні регіони обраного кластера */
export const regionFilterFor = (clusterCode: string | null): Record<string, any> => ({
    isActive: true,
    ...(clusterCode ? { 'cluster.code': clusterCode } : {}),
})
